module.exports = __webpack_public_path__ + "static/media/meal-delivery.63b1a782.jpg";